import { render } from "./CartoesServicos.vue?vue&type=template&id=c3588266&scoped=true"
import script from "./CartoesServicos.vue?vue&type=script&lang=js"
export * from "./CartoesServicos.vue?vue&type=script&lang=js"

import "./CartoesServicos.vue?vue&type=style&index=0&id=c3588266&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3588266"]])

export default __exports__